import React, { PropsWithChildren } from 'react'

import { LoaderIcon } from '@ui/components/Spinner/Loader.icon'
import type { TextColorType } from '@ui/design-system/colors/colors'

import styles from './Loader.module.scss'

export interface SpinnerProps {
  size?: SpinnerSize
  color?: TextColorType
}

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | number

type ButtonComponentProps = React.FC<PropsWithChildren<SpinnerProps>>

export const Loader: ButtonComponentProps = (props) => {
  const { size = 'md', color } = props

  const iconSize = getSize(size)

  return (
    <div className={styles.spinner}>
      <LoaderIcon size={iconSize} color={color} />
    </div>
  )
}

const getSize = (size: SpinnerSize) => {
  if (typeof size === 'number') {
    return size
  }

  return {
    xs: 24,
    sm: 32,
    md: 40,
    lg: 80,
    xl: 120,
  }[size]
}
